import React from "react";
import { Box, Stack, Button, Typography } from "@mui/joy";
import VideoOptionsModal from "../../VideoOptionsModal";
import { ErrorAlert } from "components/common/ErrorAlert";
import { ProcessingOverlay } from "components/common/ProcessingOverlay";
import { VideoPlayer } from "components/steps/RecordVideo/VideoPlayer";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";

interface RecordVideoContentProps {
  introVideo: string | null;
  showError: boolean;
  errorMessage: string;
  isProcessing: boolean;
  showOptions: boolean;
  isMuted: boolean;
  isPlaying: boolean;
  videoRef: React.RefObject<HTMLVideoElement | null>;
  fileInputRef: React.RefObject<HTMLInputElement | null>;
  onCloseError: () => void;
  onOpenOptions: () => void;
  onCloseOptions: () => void;
  onRequestCamera: () => void;
  onRequestGallery: () => void;
  onToggleMute: () => void;
  onTogglePlay: () => void;
  onFileChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const RecordVideoContent: React.FC<RecordVideoContentProps> = ({
  introVideo,
  showError,
  errorMessage,
  isProcessing,
  showOptions,
  isMuted,
  isPlaying,
  videoRef,
  fileInputRef,
  onCloseError,
  onOpenOptions,
  onCloseOptions,
  onRequestCamera,
  onRequestGallery,
  onToggleMute,
  onTogglePlay,
  onFileChange,
}) => {
  const employer = useSelector(
    (state: RootState) => state.introVideo.video?.data?.employer?.companyName
  );
  return (
    <>
      <input
        type="file"
        ref={fileInputRef}
        onChange={onFileChange}
        accept="video/*"
        style={{ display: "none" }}
      />

      <ErrorAlert
        show={showError}
        message={errorMessage}
        onClose={onCloseError}
      />

      <ProcessingOverlay isProcessing={isProcessing} />

      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Stack
          sx={{
            width: "93%",
            height: { sx: "78vh", md: "auto" },
            justifyContent: "start",
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              position: "relative",
              width: { sx: "100%", sm: "300px" },
              height: { xs: "87%", md: "100%" },
            }}
          >
            <VideoPlayer
              videoSrc={introVideo}
              isMuted={isMuted}
              isPlaying={isPlaying}
              videoRef={videoRef}
              onToggleMute={onToggleMute}
              onTogglePlay={onTogglePlay}
              videoClassName="rounded-[16px]"
            />
          </Box>
          <Typography level="dashboardHeading" sx={{mt: { xs: "12px", md: 2 },}}>{employer?.toUpperCase()}</Typography>
          <Button
            variant="solid"
            onClick={onOpenOptions}
            sx={{
              width: { xs: "100%", md: "20%" },
              mt: { xs: "12px", md: 2 },
              py: { lg: 2 },
            }}
          >
            APPLY NOW
          </Button>
        </Stack>
      </Box>

      <VideoOptionsModal
        isOpen={showOptions}
        onClose={onCloseOptions}
        onRecordVideo={onRequestCamera}
        onUploadVideo={onRequestGallery}
      />
    </>
  );
};
